<template>
  <div class="feedback-area pt-100 pb-70">
    <div class="container">
      <div class="section-title" data-aos="fade-up">
        <h2>Das sagen unsere Kunden über <span>Benovium</span></h2>
      </div>

      <div class="feedback-slides" data-aos="fade-up" data-aos-delay="200">
        <carousel
          :settings="settings"
          :wrap-around="true"
          :breakpoints="breakpoints"
        >
          <slide v-for="slide in carouselItems" :key="slide.id">
            <div class="single-feedback-item">
              <!-- <img :src="slide.image" alt="image" /> -->

              <div class="feedback-desc">
                <p>{{ slide.description }}</p>

                <div class="rating">
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                  <i class="bx bxs-star"></i>
                </div>

                <div class="client-info">
                  <h3>{{ slide.name }}</h3>
                  <span>{{ slide.position }}</span>
                </div>
              </div>
            </div>
          </slide>

          <template #addons>
            <Pagination />
            <router-link to="/contact" class="default-btn align-center">
                <i class="bx bxs-hot"></i>Kontakt aufnehmen<span></span>
            </router-link>
          </template>
        </carousel>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "WhatsOurClients",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    carouselItems: [
      {
        id: 1,
        image: require("../../assets/img/woman1.png"),
        description:
          "Hervorragende Zusammenarbeit und professionelle Umsetzung. Das Team hat unsere Erwartungen übertroffen und das Projekt termingerecht abgeliefert.",
        name: "Sarah Taylor",
        position: "Geschäftsführerin bei Envato",
      },
      {
        id: 2,
        image: require("../../assets/img/woman2.png"),
        description:
          "Kompetente Beratung und innovative Lösungen. Die Kommunikation war stets transparent und die Ergebnisse sprechen für sich.",
        name: "Olivar Lucy",
        position: "Geschäftsführerin bei HiboTheme",
      },
      {
        id: 3,
        image: require("../../assets/img/woman1.png"),
        description:
          "Zuverlässiger Partner für alle IT-Projekte. Schnelle Reaktionszeiten und exzellenter Support auch nach Projektabschluss.",
        name: "Steven Smith",
        position: "Geschäftsführer bei Envato",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      1024: {
        itemsToShow: 2,
        snapAlign: "left",
      },
      1200: {
        itemsToShow: 2,
        snapAlign: "left",
      },
    },
  }),
});
</script>
